import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, Sparkles } from "lucide-react";
import { BUSINESS } from "@/constants";

const links = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-ink/70 border-b border-bone/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="w-9 h-9 rounded-full border border-gold/60 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
            <Sparkles size={15} strokeWidth={1.5} />
          </span>
          <span className="font-serif text-xl tracking-wide text-bone">
            Shine <span className="italic text-gold">Space</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-sweep text-xs font-semibold tracking-[0.2em] uppercase text-sand hover:text-bone transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneTel}
            data-testid="nav-call-button"
            className="hidden sm:flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-bone border border-bone/20 px-5 py-2.5 rounded-full hover:border-gold hover:text-gold transition-colors duration-300"
          >
            <Phone size={13} /> {BUSINESS.phoneDisplay}
          </a>
          <a
            href="#book"
            data-testid="nav-book-button"
            className="text-xs font-semibold tracking-widest uppercase text-ink bg-gold px-5 py-2.5 rounded-full hover:bg-goldlight transition-colors duration-300"
          >
            Book Now
          </a>
        </div>
      </div>
    </motion.header>
  );
}
